import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    pi = 1,
    ps = 50,
    order = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.admin.getPage, {
        search,
        pi,
        ps,
        order,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pi, ps, pc: 0 };
};
